<template>
   <PageFull header="В.карты" type="white">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <VcardList />
            </div>  
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import PageFull from '@/components/sides/PageFull.vue'
import VcardList from '@/components/admin/vcard/list.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        PageFull,
        VcardList
    },
    methods: {
       
    },  
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>